export default __webpack_public_path__ + "static/media/section-1.2ca23e2d.png";